module.exports = function() {
  return new Worker(__webpack_public_path__ + "2094fc0ae67fb75bca62.worker.js");
};